module.exports = __webpack_public_path__ + "static/trig_001-734bba941d1162a4f15e867a0f19901f.webp";